<template>
    <v-container fluid pb-0>
       <!-- <v-row align="center" no-gutters>
            <v-col class="pb-0">
                <v-card elevation="1">
                    <v-card-actions>
                        <v-bottom-navigation
                                grow
                                class="elevation-0"
                                color="blue"
                        >
                            <v-btn
                                    :to="{name: EMPLOYEES.DOCUMENTS.route}">
                                <span>{{EMPLOYEES.DOCUMENTS.text}}</span>
                                <v-icon>{{EMPLOYEES.DOCUMENTS.icon}}</v-icon>
                            </v-btn>

                            <v-btn
                                    :to="{name: EMPLOYEES.CLIENTS.route}">
                                <span>{{EMPLOYEES.CLIENTS.text}}</span>
                                <v-icon>{{EMPLOYEES.CLIENTS.icon}}</v-icon>
                            </v-btn>

                            <v-btn
                                    :to="{name: EMPLOYEES.REPORTS.route}">
                                <span>{{EMPLOYEES.REPORTS.text}}</span>
                                <v-icon>{{EMPLOYEES.REPORTS.icon}}</v-icon>
                            </v-btn>
                        </v-bottom-navigation>
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>-->
        <!--Details View-->
        <v-row no-gutters>
            <v-col>
                <v-expansion-panels  v-if="$vuetify.breakpoint.smAndDown">
                    <v-expansion-panel>
                        <v-expansion-panel-header >Employee Information</v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <userInfoDisplay
                                    :setName="cognitoUser.attributes.name +' '+ cognitoUser.attributes.family_name"
                                    :setEmail="cognitoUser.attributes.email"
                                    :setPhone="cognitoUser.attributes.phone_number"
                                    :setType="employee.typeName"
                                    :setStatus="employee.active"
                                    setUserType="Clients"
                                    :setUserNumber="computed_employee.clients == undefined ? 0 :
                                    Object.keys(computed_employee.clients).length"
                                    :setUsername="cognitoUser.username"
                                    setCompany="Unnasigned"
                                    :setDOB="cognitoUser.attributes.birthdate"
                                    :setCreatedDate="employee.fromattedCreatedDate"
                                    :setAddress="cognitoUser.attributes.address">
                            </userInfoDisplay>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
                <userInfoDisplay v-if="$vuetify.breakpoint.mdAndUp"
                                 :setName="cognitoUser.attributes.name +' '+ cognitoUser.attributes.family_name"
                                 :setEmail="cognitoUser.attributes.email"
                                 :setPhone="cognitoUser.attributes.phone_number"
                                 :setType="employee.typeName"
                                 :setStatus="employee.active"
                                 setUserType="Clients"
                                 :setUserNumber="computed_employee.clients == undefined ? 0 :
                                  Object.keys(computed_employee.clients).length"
                                 :setUsername="cognitoUser.username"
                                 setCompany="Unnasigned"
                                 :setDOB="cognitoUser.attributes.birthdate"
                                 :setCreatedDate="employee.fromattedCreatedDate"
                                 :setAddress="cognitoUser.attributes.address">
                </userInfoDisplay>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import alertEventBus from '@/eventBus/AlertEventBus';
    import headerChartBar from '@/components/orgApps/charts/headerChartBars';
    import {EMPLOYEES} from '@/shared/enums/SubViewPathName';
    const responsiveButton = ()=> import( '@/components/common/mobile/Button');
    const userInfoDisplay = ()=> import( '@/components/common/UserInfoDisplay');

    export default {
        name: "EmployeeVerticalHeader",
        props: ["hType", "id", "path_view"],
        components: {
            responsiveButton,
            headerChartBar,
            userInfoDisplay
        },
        data() {
            return {
                type: this.hType,
                path_id: this.id,
                employee:{
                    clients: []
                },
                cognitoUser: {
                    attributes: {},
                    address:{},
                    username: ''
                },
                chartSeries: []
            }
        },
        watch:{
            id (value){
                this.path_id = value;
            },
             async hType(value){
                this.type = value;
                if(this.type === 'details')  {
                     await this.loadData()
                }
            },
        },
        computed:{
            formTitle () {
                return this.id !== undefined ? 'Edit employee' : 'New employee';
            },
            EMPLOYEES(){
                return EMPLOYEES;
            },
            computed_employee(){
                return this.$store.getters.getEmployee;
            }
        },
        methods:{
            async loadData() {
                try {
                    //call store employee
                    await this.$store.dispatch('getEmployee', {id: this.path_id});
                    let emp = this.$store.getters.getEmployee;

                    if(!!!emp){
                        throw {message: 'Not valid employee found for id:'+ this.path_id};
                    }

                    this.employee = emp;

                    let date = new Date(this.employee.systemCreatedDateTime);
                    this.employee.fromattedCreatedDate = date.toDateString();

                    let user = this.$store.getters.getCognitoUser;
                    if(user === null || user.Username !== emp.cognitoUsername) {
                        await this.$store.dispatch('getCognitoUser', {username: this.employee.cognitoUsername});
                        user = this.$store.getters.getCognitoUser;
                    }
                    if(user){
                        this.cognitoUser.username = user.Username;
                        for(let property in user.UserAttributes){
                            this.cognitoUser.attributes[user.UserAttributes[property].Name] = user.UserAttributes[property].Value;
                        }

                        this.cognitoUser.attributes.phone_number = this.cognitoUser.attributes.phone_number.replace(/\+1/,'');
                        this.cognitoUser.address = JSON.parse(this.cognitoUser.attributes.address);
                    }
                } catch (e) {
                    //set alert
                    alertEventBus.setAlert({type:'error', msg: e.message});
                    return;
                }
            },
        },
        async created() {
            await this.loadData();
        },
    }
</script>

<style scoped>

</style>